import { render, staticRenderFns } from "./BeginningDateDisplay.vue?vue&type=template&id=f2f2da26&scoped=true"
import script from "./BeginningDateDisplay.vue?vue&type=script&lang=js"
export * from "./BeginningDateDisplay.vue?vue&type=script&lang=js"
import style0 from "./BeginningDateDisplay.vue?vue&type=style&index=0&id=f2f2da26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f2da26",
  null
  
)

export default component.exports